/**
 * Debug utility for authentication and admin panel state
 */

// Create a singleton debug object
const AuthDebug = {
  // Store last auth state for debugging
  lastAuthState: {
    isAdmin: false,
    activeTab: '',
    token: null
  },
  
  // Log authentication state changes
  logAuthState: function(isAdmin, activeTab) {
    this.lastAuthState.isAdmin = isAdmin;
    this.lastAuthState.activeTab = activeTab;
    this.lastAuthState.token = localStorage.getItem('token');
    
    console.log('🔐 Auth State:', {
      isAdmin,
      activeTab,
      token: this.lastAuthState.token ? '✅ Present' : '❌ Missing'
    });
    
    return this.lastAuthState;
  },
  
  // Check if admin panel should be visible
  shouldShowAdminPanel: function(isAdmin, activeTab) {
    const shouldShow = isAdmin === true && activeTab === 'admin';
    
    console.log(`🔍 Admin Panel Visibility: ${shouldShow ? '✅ Visible' : '❌ Hidden'}`, {
      isAdminTrue: isAdmin === true,
      activeTabIsAdmin: activeTab === 'admin',
      bothConditions: isAdmin === true && activeTab === 'admin'
    });
    
    return shouldShow;
  }
};

export default AuthDebug;
